import PropTypes from 'prop-types';
import DaysInQuarter from './components/profit-share/DaysInQuarter';
import SummaryRevenueShare from './components/profit-share/SummaryRevenueShare';
import RevenueShareEarned from './components/profit-share/RevenueShareEarned';

const RevenueShare = ({statement}) => {
  return (
    <div>
      <DaysInQuarter liveDaysInQ={statement.data.liveDaysInQ} />
      <SummaryRevenueShare data={statement.data}/>
      <RevenueShareEarned data={statement.data}/>
    </div>
  )
}

export default RevenueShare;

RevenueShare.propTypes = {
  statement: PropTypes.object.isRequired,
};